import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import TextInput from '@magento/venia-ui/lib/components/TextInput';
import { isRequired } from '@magento/venia-ui/lib/util/formValidators';
import Checkbox from '@magento/venia-ui/lib/components/Checkbox';
import Field from '@magento/venia-ui/lib/components/Field';

function List(_ref) {
  var showOptionList = _ref.showOptionList,
      name = _ref.name,
      filteredResults = _ref.filteredResults,
      handleOptionClick = _ref.handleOptionClick,
      value = _ref.value,
      classes = _ref.classes,
      required = _ref.required,
      field = _ref.field,
      multiple = _ref.multiple,
      selectedValues = _ref.selectedValues,
      setSelectedValues = _ref.setSelectedValues,
      error = _ref.error;
  return React.createElement(React.Fragment, null, showOptionList === name && React.createElement("ul", {
    className: "".concat(classes['select-options']),
    role: "listbox",
    id: "select-dropdown"
  }, filteredResults !== null && filteredResults !== void 0 && filteredResults.length ? filteredResults.map(function (option, index) {
    return React.createElement("li", {
      className: "".concat(classes['custom-select-option'], " ").concat(multiple && classes.checkbox),
      "data-name": option.label,
      key: option.id || index,
      onClick: function onClick(e) {
        return !multiple && handleOptionClick(e, option);
      },
      role: "option",
      "aria-selected": false
    }, multiple ? React.createElement(Checkbox, {
      label: option.label,
      field: option === null || option === void 0 ? void 0 : option.value,
      fieldValue: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.includes(option === null || option === void 0 ? void 0 : option.value),
      onClick: function onClick(e) {
        return selectedValues !== null && selectedValues !== void 0 && selectedValues.includes(option === null || option === void 0 ? void 0 : option.value) ? setSelectedValues(selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.filter(function (val) {
          return val !== option.value;
        })) : setSelectedValues([].concat(_toConsumableArray(selectedValues), [option === null || option === void 0 ? void 0 : option.value]));
      }
    }) : option.label);
  }) : React.createElement("p", {
    className: "py-4"
  }, "No results found")), error && !value && React.createElement("p", {
    className: "text-red relative text-left"
  }, error), required && !value && React.createElement(TextInput, {
    name: name,
    field: field,
    value: value,
    placeholder: "",
    validate: isRequired
  }));
}

export default List;